<template>
    <div class="col-span-12 lg:col-span-6 overflow-hidden shadow bg-gray-200 rounded-lg relative">
        <div class="rounded-lg p-6 h-auto relative">
            <!-- Card Header -->
            <div class="mb-4 flex flex-row items-center justify-between w-full">
                <div class="flex flex-row gap-2 items-center">
                    <div class="w-6 h-6 rounded-full shimmer"></div>
                    <div class="text-slate-800 text-lg font-medium shimmer w-32 h-6"></div>
                </div>
                <div class="shimmer w-24 h-5 rounded"></div>
            </div>

            <!-- Card Title -->
            <div class="text-slate-800 font-semibold text-lg lg:text-xl xl:text-2xl shimmer w-3/4 h-8 mt-6 mb-4"></div>

            <!-- Card Content -->
            <div class="flex flex-col gap-3">
                <div class="shimmer w-full h-4"></div>
                <div class="shimmer w-full h-4"></div>
                <div class="shimmer w-5/6 h-4"></div>
            </div>

            <!-- Progress Bar -->
            <div class="mt-6 mb-4">
                <div class="shimmer w-full h-6 rounded-full"></div>
            </div>

            <!-- Card Footer -->
            <div class="bg-slate-100 rounded-md p-6 flex flex-row gap-6 items-center w-full mt-6">
                <div class="flex flex-col gap-2 w-full">
                    <div class="shimmer w-1/3 h-5"></div>
                    <div class="shimmer w-2/3 h-6"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>
